














































import { defineComponent, computed, ref, watch } from '~/utils/nuxt3-migration'
import { useI18n } from '~/compositions/i18n'
import { facetHandlerComponentProps } from '~/constants/classified/search/facet'
import useClassifiedSearchFacet from '~/compositions/classified-search/useClassifiedSearchFacet'
import CCustomSelect from '~/components/shared/configurable/form/select/custom/CCustomSelect.vue'
import { defineComponentTranslations } from '~/utils/i18n'

type PromotedValue = 'all-promoted' | 'previously-promoted' | null

export default defineComponent({
  components: { CCustomSelect },
  props: facetHandlerComponentProps,
  setup(props) {
    const { t } = useI18n()
    const { changeParams } = useClassifiedSearchFacet()

    const selectedPromotionStatus = ref<PromotedValue>(
      props.selected?.only_promoted
        ? 'all-promoted'
        : props.selected?.only_previous_promotions
        ? 'previously-promoted'
        : null
    )
    const selectedPromotionTiers = ref<string[]>(props.selected?.tiers || [])

    watch(
      () => props.selected,
      newValue => {
        selectedPromotionStatus.value = newValue?.only_promoted
          ? 'all-promoted'
          : newValue?.only_previous_promotions
          ? 'previously-promoted'
          : null
        selectedPromotionTiers.value = newValue?.tiers || []
      }
    )

    const promotionStatusOptions = computed(() => [
      {
        label: t('all'),
        value: null
      },
      {
        label: `${t('promoted_classifieds')} (${
          props.allValues.all_promoted_count
        })`,
        value: 'all-promoted'
      },
      {
        label: `${t('previously_promoted_classifieds')} (${
          props.allValues.previous_promoted
        })`,
        value: 'previously-promoted'
      }
    ])

    const promotionTiersOptions = computed(() => [
      {
        label: 'Turbo',
        value: 'turbo'
      },
      {
        label: 'Super',
        value: 'super'
      },
      {
        label: 'Top',
        value: 'top'
      }
    ])

    function onPromotionStatusChange(value: PromotedValue) {
      if (!value) {
        changeParams([
          { name: 'promotion', value: null },
          { name: 'promotion-tier', value: null },
          { name: 'has-previous-promotions', value: null }
        ])
      } else if (value === 'previously-promoted') {
        changeParams([
          { name: 'promotion', value: null },
          { name: 'promotion-tier', value: null },
          { name: 'has-previous-promotions', value: true }
        ])
      } else if (value === 'all-promoted') {
        changeParams([
          { name: 'promotion', value: true },
          { name: 'promotion-tier', value: null },
          { name: 'has-previous-promotions', value: null }
        ])
      }
    }

    function onPromotionTierChange(value: string[]) {
      changeParams([{ name: 'promotion-tier', value }])
    }

    function onPromotionStatusClear() {
      selectedPromotionStatus.value = null

      changeParams([
        { name: 'promotion', value: null },
        { name: 'promotion-tier', value: null },
        { name: 'has-previous-promotions', value: null }
      ])
    }

    function onPromotionTierClear() {
      selectedPromotionTiers.value = []

      changeParams([{ name: 'promotion-tier', value: [] }])
    }

    return {
      selectedPromotionStatus,
      selectedPromotionTiers,
      promotionStatusOptions,
      promotionTiersOptions,
      onPromotionStatusClear,
      onPromotionTierClear,
      onPromotionStatusChange,
      onPromotionTierChange
    }
  },
  i18n: defineComponentTranslations({
    promoted_classifieds: {
      en: 'Promoted',
      el: 'Προωθημένες'
    },
    previously_promoted_classifieds: {
      en: 'Previously promoted',
      el: 'Απενεργοποιημένες προωθήσεις'
    },
    promotion_tier: {
      en: 'Promotion tier',
      el: 'Επίπεδο προώθησης'
    }
  })
})
